import Axios from "@/config/AxiosConfig";

export const getLedger = async (payload) => {
    const url = `account/get-ledger/${payload.id}/${payload.type}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getMoneyIn = async () => {
    const url = `account/get-money-in-payments`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getMoneyOut = async () => {
    const url = `account/get-money-out-payments`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getFeeTypes = async () => {
    const url = `setting/fee-type/get_list`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addFeeType = async (payload) => {
    const url = `setting/fee-type/add`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const updateFeeType = async (payload) => {
    const url = `setting/fee-type/update`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const activateFeeType = async (id) => {
    const url = `setting/fee-type/activate/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const bankConnections = async () => {
    const url = `moneyhub/connections`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const bankConnect = async (id, branch_id) => {
    const url = `moneyhub/connect/${id}/${branch_id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const completeAuth = async (payload) => {
    const url = `moneyhub/complete-auth-request`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const pullStatements = async (date, page_name, branch_id) => {
    let url = "";
    if (date) {
        url = `moneyhub/accounts/${branch_id}/${page_name}/${date}`;
    } else {
        url = `moneyhub/accounts/${branch_id}/${page_name}`;
    }

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getUrl = async (payload) => {
    const url = `/moneyhub/get-url`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const get = async (payload) => {
    const url = `/moneyhub/get-url`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const patchData = async (payload) => {
    const url = `/moneyhub/get-patch-request-data`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const checkUserConnection = async (branch_id, account_type) => {
    let url;
    if (account_type) {
        url = `/moneyhub/check-user-connection/${branch_id}/${account_type}`;
    } else {
        url = `/moneyhub/check-user-connection/${branch_id}`;
    }
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getAccounts = async (account_type, branch_id) => {
    const url = `/moneyhub/check-multiple-accounts/${account_type}/${branch_id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateMoneyHubConnection = async () => {
    const url = `/moneyhub/update-moneyhub-connection`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const DisconnectUsers = async (payload) => {
    const url = `/moneyhub/delete-moneyhub-user`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const MakeSinglePayment = async (payload) => {
    const url = `/moneyhub/create-payment-request`
    try {
        const { data } = await Axios.post(url,{due_item_ids:payload});
        return data;
    } catch (e) {
        return e.response;
    }
};

export const confirmPayment = async (payload) => {
    const url = `/moneyhub/get-payment-status`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getCountTotal = async (payload) => {
    const url = `/account/get-payout-entries-data`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getfloats = async (id) => {
    const url = `/account/get-float/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const createTransfer = async (payload) => {
    const url = `/account/create-transfer`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const createFloats = async (payload) => {
    const url = `/account/create-float`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const checkTenancy = async (groupId) => {
    const url = `/account/check-contact-group/${groupId}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const deductFromFloat = async (itemId) => {
    const url = `/account/deduct-invoice-from-float/${itemId}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const GetUnreconcileMatches = async (payload) => {
    const url = `/account/get-ledger?${payload}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const GetUnreconcileMatchesTransactions = async (payload) => {
    const url = `/account/search-trans?${payload}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const ReconcileTrans = async (payload) => {
    const url = `/account/reconcile-trans`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const undoReconcileTrans = async (id) => {
    const url = `/account/unreconcile-trans?id=${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const convertDeductRent = async (payload) => {
    const url = `/account/convert-deduct-rent-to-request-payment/${payload}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addcreditNoteAgainstInvoice = async (payload) => {
    const url = `/account/create-credit-note-against-invoice`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};



export const refundReceivedInvoice  = async (payload) => {
    const url = `/account/refund-received-invoice`
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const refundReceivedRent = async (payload) => {
    const url = `/account/refund-rent`
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const voidCreditNote = async (payload) => {
    const url = `/account/void-credit-note/${payload}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};


export const changeFloatToReqPayment = async (payload) => {
    const url = `/account/change-float-to-request-payment/${payload}`
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const setIcon = (n ,r) => {
    switch (n) {
        case "invoice":
            if (r && r.charged == "monthly") {
                return "badge-percent";
            } else {
                return "file-invoice-dollar";
            }
            break;
        case "credit_note":
            return "sticky-note";
            break;
        case "rent":
            return "house-user";
            break;
        case "transfer":
            return "arrow-right-arrow-left";
            break;
        case "topup":
            return "piggy-bank";
            break;
        case "refund":
            return "house-user";
            break;
        case 'refund_invoice':
        case 'refund_rent':
            return 'undo'
            break;
        default:
            break;
    }
};

export const setIconColor = (n, l) => {
    if(l.amount.startsWith('-')){
         return '#BAC4CD'
    }else if (n === 'invoice') {
        return '#FF5EAB';
      } else if (n === 'rent') {
        return '#00B0FC';
      } else if (n === 'transfer') {
        // if (l.transfer_type === 'float') {
        //   return '#FF5C46';
        // } else {
          return '#FF5C46';
        // }
      } else if (n === 'topup') {
        return '#FFAA00';
      } else if (n === 'refund' || n === 'credit_note' ) {
        return '#BAC4CD';
      }else if(n==='refund_rent' || n === 'refund_invoice' )
      {
        return '#C65F51';
      }
      
      else {
        return ''; // or null / undefined depending on your fallback handling
      }
}


export const  generateLabels = ({ status, invoice_type, due_type, overdue, pending_in, setPendingInStatus , type })  => {
    const labels = [];
  
    // Special case: Draft + deduct_rent
    if (status === 'Draft' && invoice_type === 'deduct_rent') {
      labels.push({ text: 'Awating rent', classes: '#FFAA00' });
      labels.push({ text: status, classes: '#FFAA00' });
      if (['Received', 'Received from float'].includes(setPendingInStatus(pending_in))) {
        labels.push({ text:overdue=='0d'?'due':overdue, classes: '#FF4650' });
      }
      return labels;
    }
  
    // Special case: Paid
    if (status === 'Paid') {
      return [{ text: status, classes: '#00EBB4' }];
    }
  
    // General cases
    if (status === 'Draft' && type=='tenant') {
      labels.push({ text: status, classes: '#FF4650' });
    }
  
    if (status === 'Received' || status === 'Received from float') {
      labels.push({ text: status, classes: '#00EBB4' });
    }
  
    if (type=='tenant'  && status !== 'Received' && status !== 'Draft' && status !== 'Received from float') {
      labels.push({ text: overdue=='0d'?'due':overdue, classes: '#FF4650' });
    }
  
    // Refund-related fallback case
    if (status && due_type && due_type !== 'refund_invoice') {
      labels.push({ text: status, classes: '#FFAA00' });
    }
  
    if (setPendingInStatus && setPendingInStatus(pending_in) === 'Received') {
      labels.push({ text: overdue=='0d'?'due':overdue, type: 'overdue', classes: '#FF4650' });
    }
  
    return labels;
  }
  
export // Utility function to map payment data
const recievedMoneyInRow = (row) => ({
  
    icon: {
        color: row?.due_type == "transfer" ? "#FF5C46" : "#00B0FC",
        name: setIcon(row?.due_type),
    },
    type: "MoneyIn",
    id: row.id,
    account_type: "received",
    payment_type: setTitleHT(row.due_type, row),
    start_date: "",
    end_date: row.due_date,
    show_date: row.payment_type !== "Rent" ? true : false,
    address: row.display_address,
    credit: row.amount,
    payment_refrenace: row.payment_reference,
    due_type: row?.due_type,
    bal: "",
    user: {
        name: `${row.contact?.first_name} ${row.contact?.last_name}`,
        icon: row.contact?.badge,
        nameLetter: `${checkvalue(row.contact?.first_name).charAt(0)}${checkvalue(row.contact?.last_name).charAt(0)}`,
    },
    label: [
        {
            text: row.overdue !== "0d" ? row.overdue : "",
            classes: "#FF4650",
        },
    ],
    REF: "",
    name: "",
});
// Function to map payment data for each row
export const pendingMoneyInRow = (row1) => ({
   
    icon: {
        color: row1?.due_type == "transfer" ? "#FF5C46" : "#00B0FC",
        name: setIcon(row1?.due_type),
    },
    type: "MoneyIn",
    id: row1.id,
    account_type: "received",
    payment_type: setTitleHT(row1.due_type, row1),
    start_date: "",
    end_date: row1.due_date,
    show_date: row1.payment_type !== "Rent" ? true : false,
    address: row1.display_address,
    credit: row1.amount,
    payment_refrenace: row1.payment_reference,
    due_type: row1?.due_type,
    bal: "",
    user: {
        name: `${row1.contact.first_name} ${row1.contact.last_name}`,
        icon: row1.contact.badge,
        nameLetter: `${row1.contact.first_name.charAt(0)}${checkvalue(row1.contact.last_name).charAt(0)}`,
    },
    label: [
        {
            text: row1.overdue !== "0d" ? row1.overdue : "",
            classes: "#FF4650",
        },
    ],
    REF: "",
    name: "",
});

export const setTitleHT = (n, row) => {
    if (n !== "transfer") {
        return row.payment_type;
    }

    const { transfer_contact } = row;
    const { first_name, last_name } = transfer_contact;
    const a = row.status == "Received from float" || (row.status == "Received" && n == "transfer") ? "to" : "from";

    return `Transfer ${a} ${first_name} ${last_name}`;
};
export const unReconcileFormateData = (row) => (
    console.log(row , 'unReconcileFormateData'),
    {
    id: row.id,
    icon: "",
    type: "Client",
    account_type: "Unreconciled",
    property_type: "",
    start_date: formateDate(row.date.slice(0, 10)),
    end_date: "",
    address: "",
    credit: formatCurrency(row),
    isCredit: row.value > 0 ? true : false,
    bal: "",
    user: "",
    label: [{ text: "Unreconciled", classes: "#FFAA00" }],
    REF: row.transactionInformation,
    name: "James jones " + formateDate(row.date.slice(0, 10)),
    checked: false,
});
export const checkvalue = (val) => {
    if (val) {
        return val;
    } else {
        return "";
    }
};
export const formateDate = (d) => {
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    const date = new Date(d);
    return date.toLocaleDateString("en-GB", options);
};

export const formatCurrency = (row) => {
    const currencySymbol = "£"; // Can be dynamic if needed
    const value = row.value;
    const majorUnits = Math.abs(row.majorUnits); // Always positive number

    const sign = value > 0 ? "+" : value < 0 ? "-" : "";

    return `${sign}${currencySymbol}${majorUnits}`;
};
export const reconcileLedgerRow = (row, isCredit = false) => {
    // Destructure the fields we need from `row`
    const {
        id,
        due_type,
        transfer_type,
        from_date,
        display_address,
        amount,
        invoice_id,
        payment_reference,
        contact_group_id,
        status,
        contacts,
    } = row;

    // Build the `user` object (using optional chaining)
    const firstContact = contacts[0] || {};
    const firstName = firstContact.first_name || "";
    const lastName = firstContact.last_name || "";

    return {
        id,
        entery_type: "tenant",
        icon: {
            color: setIconColor(due_type, row),
            name: setIcon(due_type),
        },
        type: "Deposit",
        account_type: "account",
        property_type: "",
        start_date: from_date,
        end_date: from_date,
        show_date:
          due_type === "transfer" && transfer_type !== "float"
            ? false
            : true,
        address: display_address,
        credit: isCredit
          ? `+£${amount}`
          : `-£${amount}`,
        show_credit: amount,
        invoiceId: invoice_id,
        invoice_status: null,
        due_type,
        payment_refrenace: payment_reference,
        received_amount: 0,
        received_amount_title: "Amount is £0",
        contact_group_id,
        bal: "",
        user: {
            name: `${firstName} ${lastName}`,
            icon: firstContact.badge,
            nameLetter: `${firstName.charAt(0) || ""}${
              lastName.charAt(0) || ""
            }`,
        },
        label: [
            { text: status === "Draft" ? status : "", classes: "#FF4650" },
            { text: status === "Received" ? status : "", classes: "#00EBB4" },
            {
                text:
                  status === "Received from float" ? status : "",
                classes: "#00EBB4",
            },
        ],
        REF: "",
        name: "",
        deposit_title: setTitle(due_type, row, "tenant"),
        contact_group_id,
        contacts,
    };
};


export const setTitle = (n, row, type) => {
    if (n !== "transfer") {
        const paymentType = row.payment_type;
        const dateRange = row.due_type !== "invoice" ? `${row.from_date}-${row.due_date}` : "";
        return `${paymentType?.charAt(0)?.toUpperCase()}${paymentType?.slice(1) || ""} ${dateRange}`;
    }

    const { transfer_contact } = row;
    const { first_name, last_name } = transfer_contact[0];
    return `Transfer ${type === "tenant" ? "to" : "from"} ${first_name} ${last_name}`;
};
